__turbopack_context__.v({
  "animateOnHoverDesktop": "shadowBox-module-scss-module__OU2feG__animateOnHoverDesktop",
  "animateOnHoverMobile": "shadowBox-module-scss-module__OU2feG__animateOnHoverMobile",
  "shadowBox": "shadowBox-module-scss-module__OU2feG__shadowBox",
});
